import type { ISpread } from "../../spreadsSlice";

export const relationshipsSpread: ISpread = {
  id: "spread_relationships",
  name: "Отношения",
  altNames: ["Relationship Spread"],
  purpose:
    "Анализ текущей динамики между двумя людьми, сильных и слабых сторон связи, скрытых факторов и возможного направления развития.",
  cardsCount: 7,
  layout: `      [4]
[1] [2] [3]
      [5]
   [6] [7]`,
  positions: [
    {
      id: "self",
      title: "Вы",
      meaning: "Ваше восприятие отношений.",
    },
    {
      id: "other",
      title: "Другой человек",
      meaning: "Восприятие отношений другим человеком.",
    },
    {
      id: "relationship",
      title: "Суть отношений",
      meaning: "Центральная динамика и реальное состояние связи.",
    },
    {
      id: "bond",
      title: "Что связывает",
      meaning: "Объединяющая энергия отношений.",
    },
    {
      id: "separation",
      title: "Что разделяет",
      meaning: "Фактор разобщения, напряжения или дистанции.",
    },
    {
      id: "self_role",
      title: "Ваша роль",
      meaning: "То, что вы привносите в отношения.",
    },
    {
      id: "potential",
      title: "Потенциал / итог",
      meaning: "Вероятное направление дальнейшего развития отношений.",
    },
  ],
  symbolism:
    "Центральные позиции показывают основу взаимосвязи, позиции объединения и разделения раскрывают внутреннее напряжение связи, а заключительные позиции показывают вклад человека и потенциал развития.",
  archetypes: ["Партнёрство", "Связь", "Притяжение и разделение"],
  psychology:
    "Помогает увидеть различие между ожиданиями и реальной динамикой, осознать эмоциональные потребности и внутренние мотивы обеих сторон.",
  procedure: {
    preparation:
      "Сформулировать вопрос о конкретных отношениях и их текущем состоянии.",
    steps:
      "Перетасовать карты; выложить семь карт по порядку; сначала рассмотреть восприятие двух людей и суть отношений, затем объединяющий и разделяющий факторы, после этого роль и потенциал.",
  },
  interpretations: [
    "Сильный контраст между тем, что связывает и разделяет, может показывать внутренний конфликт отношений.",
    "Позиция сути отношений может отличаться от субъективного восприятия обоих людей.",
    "Потенциал показывает направление развития, а не неизбежный финал.",
  ],
  nuances: [
    "Не сводить отношения только к чувствам одного человека.",
    "Особенно важно сопоставлять позиции «Вы», «Другой человек» и «Суть отношений».",
    "Сложная карта в итоговой позиции не является автоматически окончательным приговором.",
  ],
  examples: [],
  selfQuestions: [
    "Чего я жду от этих отношений?",
    "Что связывает и что разъединяет нас?",
    "Куда реально движется эта связь?",
  ],
};

